/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { UniversalSavedSearchHitSchema } from './universalSavedSearchHitSchema';

export interface UniversalSavedSearchGroupSchema {
  items: UniversalSavedSearchHitSchema[];
  has_more: boolean;
}
